import { Box } from "grommet";
import { find, flatten, orderBy } from "lodash";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useQuery, useQueryNumber, useQuerySwitch } from "../general/Helpers";
import LiveHub from "../general/LiveHub";
import { AliasMatchParticipantViewModel, MatchParticipantViewModel, MatchViewModel } from "../matches/MatchesStore";
import { MatchRow } from "../matches/MatchRow";
import { TeamName } from "../teams/TeamName";
import { TeamViewModel } from "../teams/TeamsStore";
import TournamentBracket from "./TournamentBracket";
import { RenderWinner } from "./TournamentProfile";
import { AliasTournamentParticipantViewModel, getTournament, PastMatches, TournamentViewModel, UpcomingMatches } from "./TournamentsStore";
import { AliasTile } from "../aliases/AliasTile";

export const getNextMatch = (tournament: TournamentViewModel, n: number) => {
    let upcomingMatches = UpcomingMatches(tournament);
    let pastMatches = PastMatches(tournament);

    let match = upcomingMatches[n];
    if (!match) {
        match = pastMatches[n];
    }

    return match?.match;
};

export const TournamentMatchRowWrapper = () => {
    let { id } = useParams<{ id: string }>();
    const [match, setMatch] = React.useState(new MatchViewModel());

    React.useEffect(() => {
        resolve();
    }, []);

    const matchNumber = useQueryNumber("matchNumber", 0);

    const resolve = () => {
        getTournament(id).then((tournament) => {
            let match = getNextMatch(tournament, matchNumber);
            if (match) {
                setMatch(match);
            } else {
                setMatch(new MatchViewModel());
            }
            console.log("interactive");
        });
    };

    return (
        <LiveHub entities={[id]} handleUpdate={resolve}>
            <MatchRow match={match}></MatchRow>
        </LiveHub>
    );
};

export const TournamentTeamNameWrapper = () => {
    let { id, participant } = useParams<{ id: string; participant: string }>();
    const [team, setTeam] = React.useState({} as TeamViewModel);

    React.useEffect(() => {
        resolve();
    }, []);

    const matchNumber = useQueryNumber("matchNumber", 0);

    const resolve = () => {
        getTournament(id).then((tournament) => {
            let match = getNextMatch(tournament, matchNumber);
            if (match) {
                setTeam(match.participants[+participant].team);
            } else {
                setTeam({} as TeamViewModel);
            }
            console.log("interactive");
        });
    };

    const useTeamColor = useQuerySwitch("useTeamColor");

    return (
        <LiveHub entities={[id]} handleUpdate={resolve}>
            <TeamName team={team} size="7rem" color={useTeamColor ? team.color : ""}></TeamName>
        </LiveHub>
    );
};

export const TournamentTeamPlayersWrapper = () => {
    let { id, participant } = useParams<{ id: string; participant: string }>();
    const [participants, setParticipants] = React.useState([] as AliasMatchParticipantViewModel[]);

    React.useEffect(() => {
        resolve();
    }, []);

    const matchNumber = useQueryNumber("matchNumber", 0);

    const resolve = () => {
        getTournament(id).then((tournament) => {
            let match = getNextMatch(tournament, matchNumber);
            if (match) {
                setParticipants(match.participants[+participant].aliases);
            } else {
                setParticipants([] as AliasMatchParticipantViewModel[]);
            }
            console.log("interactive");
        });
    };

    const useTeamColor = useQuerySwitch("useTeamColor");

    return (
        <LiveHub entities={[id]} handleUpdate={resolve}>
            <Box justify="evenly" direction="row">
                {participants.map((participant) => (
                    <AliasTile alias={participant.alias} profileOnly key={participant.id} size="large"></AliasTile>
                ))}
            </Box>
        </LiveHub>
    );
};

export const TournamentTeamPlayerWrapper = () => {
    let { id, participant, player } = useParams<{ id: string; participant: string; player: string }>();
    const [participantAlias, setParticipantAlias] = React.useState({} as AliasMatchParticipantViewModel);

    React.useEffect(() => {
        resolve();
    }, []);

    const matchNumber = useQueryNumber("matchNumber", 0);

    const resolve = () => {
        getTournament(id).then((tournament) => {
            let match = getNextMatch(tournament, matchNumber);
            if (match) {
                try {
                    setParticipantAlias(match.participants[+participant]?.aliases[+player] || {});
                } catch (e) {
                    setParticipantAlias({} as AliasMatchParticipantViewModel);
                }
            } else {
                setParticipantAlias({} as AliasMatchParticipantViewModel);
            }
            console.log("interactive");
        });
    };

    const useTeamColor = useQuerySwitch("useTeamColor");

    return (
        <LiveHub entities={[id]} handleUpdate={resolve}>
            <Box justify="evenly" direction="row">
                {participantAlias.aliasID && <AliasTile alias={participantAlias.alias} profileOnly size="large"></AliasTile>}
            </Box>
        </LiveHub>
    );
};

export const TournamentTeamLogoWrapper = () => {
    let { id, participant } = useParams<{ id: string; participant: string }>();
    const [team, setTeam] = React.useState({} as TeamViewModel);

    React.useEffect(() => {
        resolve();
    }, []);

    const matchNumber = useQueryNumber("matchNumber", 0);

    const resolve = () => {
        getTournament(id).then((tournament) => {
            let match = getNextMatch(tournament, matchNumber);
            if (match) {
                setTeam(match.participants[+participant].team);
            } else {
                setTeam({} as TeamViewModel);
            }

            console.log("interactive");
        });
    };

    return (
        <LiveHub entities={[id]} handleUpdate={resolve}>
            <img src={team.logoUri} width="240px" alt="" />
        </LiveHub>
    );
};

export const TournamentTeamNameLogoWrapper = () => {
    let { id, participant } = useParams<{ id: string; participant: string }>();
    const [team, setTeam] = React.useState({} as TeamViewModel);

    React.useEffect(() => {
        resolve();
    }, []);

    const matchNumber = useQueryNumber("matchNumber", 0);

    const resolve = () => {
        getTournament(id).then((tournament) => {
            let match = getNextMatch(tournament, matchNumber);
            if (match) {
                setTeam(match.participants[+participant].team);
            } else {
                setTeam({} as TeamViewModel);
            }
            console.log("interactive");
        });
    };

    const reverse = useQuerySwitch("reVerse");
    const useTeamColor = useQuerySwitch("useTeamColor");
    return (
        <LiveHub entities={[id]} handleUpdate={resolve}>
            {reverse && (
                <Box direction="row" align="center" justify="end" gap="small" fill="horizontal">
                    <TeamName team={team} size="7rem" color={useTeamColor ? team.color : ""}></TeamName>
                    <img src={team.logoUri} width="240px" alt="" />
                </Box>
            )}
            {!reverse && (
                <Box direction="row" align="center" justify="start" gap="small" fill="horizontal">
                    <img src={team.logoUri} width="240px" alt="" />
                    <TeamName team={team} size="7rem" color={useTeamColor ? team.color : ""}></TeamName>
                </Box>
            )}
        </LiveHub>
    );
};

export const TournamentBracketWrapper = () => {
    let { id } = useParams<{ id: string }>();
    const [tournament, setTournament] = React.useState(new TournamentViewModel());

    React.useEffect(() => {
        resolve();
    }, []);

    const resolve = () => {
        getTournament(id).then((tournament) => {
            setTournament(tournament);
            console.log("interactive");
        });
    };

    let navigate = useNavigate();

    return (
        <LiveHub entities={[id]} handleUpdate={resolve}>
            <TournamentBracket tournament={tournament} onClick={(tournamentMatch) => navigate("/matches/" + tournamentMatch.match.id)}></TournamentBracket>
        </LiveHub>
    );
};

export const TournamentWinnerWrapper = () => {
    let { id } = useParams<{ id: string; participant: string }>();
    const [tournament, setTournament] = React.useState(new TournamentViewModel());

    React.useEffect(() => {
        resolve();
    }, []);

    const resolve = () => {
        getTournament(id).then((tournament) => {
            setTournament(tournament);
            console.log("interactive");
        });
    };

    return (
        <LiveHub entities={[id]} handleUpdate={resolve}>
            {tournament.bracket?.finals?.winner && <RenderWinner size={5} tournamentMatch={tournament.bracket?.finals}></RenderWinner>}
        </LiveHub>
    );
};

export const TournamentWinnerTeamNameWrapper = () => {
    let { id, participant } = useParams<{ id: string; participant: string }>();
    const [team, setTeam] = React.useState({} as TeamViewModel);

    React.useEffect(() => {
        resolve();
    }, []);

    const resolve = () => {
        getTournament(id).then((tournament) => {
            if (tournament.bracket.finals?.winner) {
                setTeam(find(tournament.bracket.finals.match.participants, { teamID: tournament.bracket.finals?.winner }).team);
            } else {
                setTeam({} as TeamViewModel);
            }
            console.log("interactive");
        });
    };

    const useTeamColor = useQuerySwitch("useTeamColor");

    return (
        <LiveHub entities={[id]} handleUpdate={resolve}>
            <TeamName team={team} size="7rem" color={useTeamColor ? team.color : ""}></TeamName>
        </LiveHub>
    );
};

export const TournamentWinnerTeamLogoWrapper = () => {
    let { id, participant } = useParams<{ id: string; participant: string }>();
    const [team, setTeam] = React.useState({} as TeamViewModel);

    React.useEffect(() => {
        resolve();
    }, []);

    const matchNumber = useQueryNumber("matchNumber", 0);

    const resolve = () => {
        getTournament(id).then((tournament) => {
            if (tournament.bracket.finals?.winner) {
                setTeam(find(tournament.bracket.finals.match.participants, { teamID: tournament.bracket.finals?.winner }).team);
            } else {
                setTeam({} as TeamViewModel);
            }
            console.log("interactive");
        });
    };

    return (
        <LiveHub entities={[id]} handleUpdate={resolve}>
            <img src={team.logoUri} width="240px" alt="" />
        </LiveHub>
    );
};

export const TournamentWinnerTeamNameLogoWrapper = () => {
    let { id, participant } = useParams<{ id: string; participant: string }>();
    const [team, setTeam] = React.useState({} as TeamViewModel);

    React.useEffect(() => {
        resolve();
    }, []);

    const resolve = () => {
        getTournament(id).then((tournament) => {
            if (tournament.bracket.finals?.winner) {
                setTeam(find(tournament.bracket.finals.match.participants, { teamID: tournament.bracket.finals?.winner }).team);
            } else {
                setTeam({} as TeamViewModel);
            }
            console.log("interactive");
        });
    };

    const useTeamColor = useQuerySwitch("useTeamColor");
    return (
        <LiveHub entities={[id]} handleUpdate={resolve}>
            <Box direction="row" align="center" justify="start" gap="small" fill="horizontal">
                <img src={team.logoUri} width="240px" alt="" />
                <TeamName team={team} size="7rem" color={useTeamColor ? team.color : ""}></TeamName>
            </Box>
        </LiveHub>
    );
};
